module.exports = __webpack_public_path__ + "static/media/whiteLogo.bfb4d7c0.png";